import { ImageWarnings, WarningDefinitionData, Warnings } from "@nova/constants"
import { PanoramaState } from "./PanoramaSlice"

// success and warning messages are not meant to be shown externally
export const panoramaWarningDefinitions: WarningDefinitionData = {
    metadata: {
        type: Warnings.Warning,
        name: "Metadata",
        successMessage: "Panorama has required metadata",
        successStatus: "Valid",
    },
    manufacturer: {
        type: Warnings.Warning,
        name: "Manufacturer",
        successMessage: "Panorama was created by a DJI drone",
        successStatus: "DJI",
    },
    imageType: {
        type: Warnings.Warning,
        name: "Type",
        successMessage: "Image is a Pano",
        successStatus: "Pano",
    },
    quantity: {
        type: Warnings.Error,
        name: "Quantity",
        successStatus: "The correct number of files have been uploaded",
        successMessage: "Correct",
    },
}

export const panoramaWarningProcessor = (uploads: PanoramaState[]) => {
    const warnings: ImageWarnings = {}
    if (uploads.length !== 1) {
        warnings["quantity"] = {
            status: "Incorrect",
            warning: "Only one panorama can be selected at a time",
            type: Warnings.Error,
        }
        return { warnings }
    }
    if (!uploads[0].longitude || !uploads[0].latitude) {
        warnings.metadata = {
            status: "Invalid",
            warning: "Cannot get coordinate metadata from pano",
        }
    }
    if (uploads[0].make !== "dji") {
        warnings.manufacturer = {
            status: "Invalid",
            warning: "Pano is missing DJI metadata",
        }
    } else if (!uploads[0].isPano) {
        warnings.imageType = {
            status: "Invalid",
            warning: "DJI image is not a pano",
        }
    }

    return { warnings }
}
